export default "__VITE_ASSET__d4bf2ec1__"